import { UsersAppBaseDataProvider } from './UsersAppBaseDataProvider';
import { UsersAppWebComponentSchema } from '../types';

export class UsersAppNirvanaDataProvider extends UsersAppBaseDataProvider {
  async getDataForView(): Promise<UsersAppWebComponentSchema> {
    return {} as unknown as UsersAppWebComponentSchema;
  }
}
